import * as type from "../types";

export function getActiveCertificatesRequest(reqParams) {
  return {
    type: type.GET_ACTIVE_CERTIFICATES_REQUESTED,
    payload: reqParams,
  };
}

export function getActiveCertificatesSucceeded(data) {
  return {
    type: type.GET_ACTIVE_CERTIFICATES_SUCCEEDED,
    payload: data,
  };
}

export function getActiveCertificatesFailed() {
  return {
    type: type.GET_ACTIVE_CERTIFICATES_FAILED,
  };
}

export function getSuspendedCertificatesRequest(reqParams) {
  return {
    type: type.GET_SUSPENDED_CERTIFICATES_REQUESTED,
    payload: reqParams,
  };
}

export function getSuspendedCertificatesSucceeded(data) {
  return {
    type: type.GET_SUSPENDED_CERTIFICATES_SUCCEEDED,
    payload: data,
  };
}

export function getSuspendedCertificatesFailed() {
  return {
    type: type.GET_SUSPENDED_CERTIFICATES_FAILED,
  };
}

export function getCanceledCertificatesRequest(reqParams) {
  return {
    type: type.GET_CANCELED_CERTIFICATES_REQUESTED,
    payload: reqParams,
  };
}

export function getCanceledCertificatesSucceeded(data) {
  return {
    type: type.GET_CANCELED_CERTIFICATES_SUCCEEDED,
    payload: data,
  };
}

export function getCanceledCertificatesFailed() {
  return {
    type: type.GET_CANCELED_CERTIFICATES_FAILED,
  };
}

export function getRedemptionUsableCertificatesRequest(reqParams) {
  return {
    type: type.GET_REDEMPTION_USABLE_CERTIFICATES_REQUESTED,
    payload: reqParams,
  };
}

export function getRedemptionUsableCertificatesSucceeded(data) {
  return {
    type: type.GET_REDEMPTION_USABLE_CERTIFICATES_SUCCEEDED,
    payload: data,
  };
}

export function getRedemptionUsableCertificatesFailed() {
  return {
    type: type.GET_REDEMPTION_USABLE_CERTIFICATES_FAILED,
  };
}

export function setCertificateFilterStation(payload) {
  return {
    type: type.SET_CERTIFICATE_FILTER_STATION,
    payload: payload,
  };
}

export function setCertificateFilterResourceType(payload) {
  return {
    type: type.SET_CERTIFICATE_FILTER_RESOURCE_TYPE,
    payload: payload,
  };
}

export function setCertificateFilterProductionPeriod(payload) {
  return {
    type: type.SET_CERTIFICATE_FILTER_PRODUCTION_PERIOD,
    payload: payload,
  };
}

export function setCertificateFilterExportStartDate(payload) {
  return {
    type: type.SET_CERTIFICATE_FILTER_EXPORT_START_DATE,
    payload: payload,
  };
}
export function setCertificateFilterExportEndDate(payload) {
  return {
    type: type.SET_CERTIFICATE_FILTER_EXPORT_END_DATE,
    payload: payload,
  };
}
